module.exports = __webpack_public_path__ + "static/media/tokiwa10-3.ccfd0e10.jpg";